import script from "./loading-spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./loading-spinner.vue?vue&type=script&lang=ts&setup=true"

import "./loading-spinner.vue?vue&type=style&index=0&id=5fc4a63f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc4a63f"]])

export default __exports__